import { includes } from 'ramda';
import { Routes } from '../../common/enums/Routes';
import { IContact } from '../../common/models/contact/IContact';

export const routeTitles: Record<string, string> = {
  [Routes.Candidates]: 'Candidates | KodiakHR',
  [Routes.Positions]: 'Positions | KodiakHR',
  [Routes.Surveys]: 'Surveys | KodiakHR',
  [Routes.Prospects]: 'Prospects | KodiakHR',
  [Routes.Dashboard]: 'Dashboard | KodiakHR',
  [Routes.Settings]: 'Settings | KodiakHR',
  refReq: 'New Request | KodiakHR'
};

export const setPositionProfileTitle = (positionName: string | undefined) => {
  if (positionName) {
    document.title = `${positionName} | KodiakHR`;
  }
};

export const setContactProfileTitle = (contact: IContact | undefined) => {
  if (contact) {
    document.title = `${contact.firstName} ${contact.lastName} | KodiakHR`;
  }
};

export const setRouteTitle = (pathname: string) => {
  if (includes(Routes.Settings, pathname)) {
    document.title = routeTitles[Routes.Settings];
  } else if (includes(Routes.Dashboard, pathname)) {
    document.title = routeTitles[pathname];
  }
};
